import { Check, Close } from '@mui/icons-material';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../Button';

interface CreateBscSuccessModalProps {
    open: boolean;
    onClose: () => void;
}

const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 16px;
        padding: 1rem;
        min-width: 480px;
        max-width: 600px;
        ${({ theme }) => theme.mediaWidth.upToSmall`
        max-width: unset;
        min-width: unset;
        width:100vw;
        margin: 10px;
        padding: 1rem;
        height: auto;
        `};
    }
`;

const StyledDialogTitle = styled(DialogTitle)`
    text-align: center;
    font-weight: 600;
    font-size: 1.5rem;
    color: #333;
    padding-bottom: 1rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CloseButton = styled(IconButton)`
    position: absolute;
    right: 8px;
    top: 8px;
    color: #666;

    &:hover {
        color: #333;
        background-color: #f5f5f5;
    }
`;

const SuccessBox = styled(Box)`
    text-align: center;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;

const SuccessIcon = styled(Check)`
    font-size: 4rem;
    color: #4caf50;
    background: #e8f5e8;
    border-radius: 50%;
    padding: 1rem;
`;

export default function CreateBscSuccessModal({
    open,
    onClose,
}: CreateBscSuccessModalProps) {
    const history = useHistory();

    const handleGoToMyLazbubu = () => {
        onClose();
        history.push('/my');
    };

    return (
        <StyledDialog
            open={open}
            onClose={() => {}} // 禁用所有默认的关闭行为
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown={true} // 禁用ESC键关闭
            BackdropProps={{
                onClick: () => {}, // 禁用点击背景关闭
            }}
        >
            <StyledDialogTitle>
                <span>🎉 Lazbubu Created Successfully!</span>
                <CloseButton onClick={onClose} size="small">
                    <Close />
                </CloseButton>
            </StyledDialogTitle>

            <DialogContent>
                <SuccessBox>
                    <SuccessIcon />
                    <Typography variant="h6" color="#000">
                        Congratulations! Your Lazbubu has been created
                        successfully
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        You can now start interacting with your Lazbubu
                    </Typography>
                    <Button onClick={handleGoToMyLazbubu} size="small">
                        Go to My Lazbubu
                    </Button>
                </SuccessBox>
            </DialogContent>
        </StyledDialog>
    );
}
